export const SET_FOCUS = 'Editor/Focus/SET_FOCUS';
export const SET_DOCUMENT_FOCUS = 'Editor/Focus/SET_DOCUMENT_FOCUS';
